import PropTypes from 'prop-types';

export const props = {
  modal: PropTypes.bool,
  loginCallBack: PropTypes.func,
};
